<template>
<transition name="slide">
  <el-dialog :class="['setting-sliding','sliding',bodyHeightClass, popupClass]" :modal-class="modalClass" :title="title" :visible.sync="visible" :close-on-click-modal="closeOnClickModal" top="0px" :width="width" @open="open" @close="close" :modal-append-to-body="modalAppendToBody"
    :append-to-body="appendToBody" :modal="true">
    <el-scrollbar class="bar-visible">
      <div class="body-content">
        <slot name="content" />
      </div>
    </el-scrollbar>
    <div slot="footer">
      <slot name="footer" />
    </div>
  </el-dialog>
</transition>
</template>

<script>
import isNil from 'lodash/isNil';

export default {
  name: 'WSettingSlidingPopup',
  props: {
    title: {
      type: String,
    },
    width: {
      type: String,
      default: '50%',
    },
    popupClass: {
      type: String,
    },
    modalClass: {
      type: String,
      default: 'setting-sliding',
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    modalAppendToBody: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    bodyHeightClass() {
      if (isNil(this.$slots.footer)) {
        return 'no-footer';
      }
      return 'include-footer';
    },
    showFullscreenLayer() {
      return this.$store.state.common.showFullscreenLayer;
    },
  },
  watch: {
    showFullscreenLayer(to) {
      if (to === false && this.visible === true) {
        this.close();
      }
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.$emit('open');
    },
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/SettingSlidingPopup/SettingSlidingPopup.vue